import React from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';

import PropTypes from 'prop-types';

class Forms extends React.Component {
    constructor(props) {
        super(props);

        let v = this.props.value;

        if ((v === '' || v === undefined) && this.props.items.length > 0) {
            const item = this.props.items[0];
            v = this.props.show_key === '' ? item : item[this.props.show_key];
        }

        if (this.props.multiple) {
            var array = v.split(',');

            this.state = {
                value: array,
                items: this.props.items,
            };
        } else {
            this.state = {
                value: v,
                items: this.props.items,
            };
        }
    }

    // /**
    //  * Props 변경시
    //  * @param nextProps
    //  */
    // componentWillReceiveProps(nextProps) {
    //     let v = nextProps.value;
    //     if ((v === "" || v === undefined) && nextProps.items.length > 0) {
    //         const item = nextProps.items[0];
    //         v = nextProps.show_key === "" ? item : item[nextProps.show_key];
    //     }

    //     this.setState({
    //         value: nextProps.value,
    //         items: nextProps.items
    //     });
    // }

    /**
     * 기본 데이터 변경시
     * @param  e
     */
    onChange = e => {
        if (this.props.multiple) {
            let value = Array.from(e.target.selectedOptions, option => option.value);
            // this.setState({
            //     value: value
            // });
            this.setVal(value);
        } else {
            // this.setState({
            //     value: e.target.value
            // });
            this.setVal(e.target.value);
        }

        if (this.props.onChange !== undefined) {
            this.props.onChange(e);
        }
    };

    // /**
    //  * 값 가져오기
    //  */
    // getVal = () => {
    //     if (this.props.multiple) {
    //         return this.state.value.toString();
    //     }

    //     return this.state.value;
    // };

    // setItems = items => {
    //     this.setState({
    //         items: items
    //     });
    // };

    setVal = val => {
        if (this.props.parent !== undefined) {
            const array = this.props.name.split('/');
            if (array.length > 1) {
                // const key = array[0];
                const x = (array, obj) => {
                    if (array.length === 1) {
                        obj[array[0]] = val;
                        return obj;
                    }
                    const key = array.shift();
                    obj[key] = x(array, obj[key]);
                    return obj;
                };

                x(array, this.props.parent.state);
                this.props.parent.setState({});
            } else {
                const data = this.props.parent.state.data;
                data[this.props.name] = val;

                this.props.parent.setState({
                    data: data,
                });
            }
        }
    };

    renderControl = () => {
        return (
            <Form.Control as="select" onChange={this.onChange} value={this.props.value} disabled={this.props.disabled} multiple={this.props.multiple}>
                {this.props.default === '' ? '' : <option>{this.props.default}</option>}

                {this.state.items.map(item => (
                    <option
                        value={this.props.show_key === '' ? item : item[this.props.show_key]}
                        key={this.props.show_key === '' ? item : item[this.props.show_key]}
                    >
                        {this.props.show_val === '' ? item : item[this.props.show_val]}
                    </option>
                ))}
            </Form.Control>
        );
    };

    render() {
        if (this.props.show_sub_title) {
            return (
                <InputGroup className="mb-3" size="sm">
                    <Button variant="secondary">{this.props.title}</Button>
                    {this.renderControl()}
                </InputGroup>
            );
        } else if (this.props.show_title) {
            return (
                <Form.Group>
                    <Form.Label>{this.props.title}</Form.Label>
                    {this.renderControl()}
                </Form.Group>
            );
        } else {
            return this.renderControl();
        }
    }
}

Forms.defaultProps = {
    title: '',
    value: '',
    items: [],
    default: '',
    show_key: '',
    show_val: '',
    disabled: false,
    multiple: false,
    show_title: true,
    show_sub_title: false,
};

Forms.propTypes = {
    title: PropTypes.string,
};

export default Forms;
